// Central content data for Naparstek Digital.

export const REAL_PROJECTS = [
  {
    index: "01",
    slug: "alpaca-furniture",
    title: "Alpaca Furniture Revitalization",
    category: "Furniture Restoration — Kansas City",
    url: "https://alpaca-furniture-revitalization.alec-naparstek.workers.dev/",
    display: "alpacafurniture.com",
    shot: "https://image.thum.io/get/width/1280/crop/1000/noanimate/https://alpaca-furniture-revitalization.alec-naparstek.workers.dev/",
    fallback:
      "https://images.pexels.com/photos/29917912/pexels-photo-29917912.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "A furniture revitalization studio in Kansas City that turns tired old pieces into something people fall in love with again. The site leans into the craft — clean before-and-after pairings, warm neutrals, and room to let each piece breathe.",
    highlights: ["Editorial layout", "Before / after showcase", "Warm minimal palette", "Craft-first storytelling"],
  },
  {
    index: "02",
    slug: "stripes-lawn-care",
    title: "Stripes Lawn Care",
    category: "Local Service — Olathe, Kansas",
    url: "https://stripes-lawn-care.alec-naparstek.workers.dev/",
    display: "stripes.com",
    shot: "https://image.thum.io/get/width/1280/crop/1000/noanimate/https://stripes-lawn-care.alec-naparstek.workers.dev/",
    fallback:
      "https://images.pexels.com/photos/3999647/pexels-photo-3999647.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "A local lawn care business that needed to look as sharp as the yards they cut. Bold green branding, pricing you can actually understand, and a quote button that's never more than a tap away.",
    highlights: ["Clear pricing tiers", "Bold local branding", "Service breakdown", "Fast path to a quote"],
  },
];

export const CONCEPTS = [
  {
    label: "Concept Design",
    title: "Ember & Oak",
    category: "Wood-Fired Kitchen",
    image:
      "https://images.unsplash.com/photo-1526069631228-723c945bea6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    label: "Concept Design",
    title: "Northline Dental",
    category: "Dental Care",
    image:
      "https://images.unsplash.com/photo-1629909613654-28e377c37b09?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    label: "Concept Design",
    title: "Fieldhouse Remodeling",
    category: "Home Renovation",
    image:
      "https://images.unsplash.com/photo-1505798577917-a65157d3320a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    label: "Concept Design",
    title: "Ironside Barbell Club",
    category: "Strength Gym",
    image:
      "https://images.pexels.com/photos/19025673/pexels-photo-19025673.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=700&w=1000",
  },
];

export const SERVICES = [
  { num: "01", title: "Website Design", desc: "Custom websites designed around your business, customers, and brand." },
  { num: "02", title: "Website Redesign", desc: "Transform an outdated website into a modern, professional online presence." },
  { num: "03", title: "Mobile Optimization", desc: "Make sure your website looks and works beautifully across phones, tablets, and desktops." },
  { num: "04", title: "Website Updates", desc: "Keep your website current with new photos, services, pricing, information, and design updates." },
  { num: "05", title: "Landing Pages", desc: "Focused pages designed to turn visitors into customers." },
  { num: "06", title: "Business Website Setup", desc: "Get your business online with a professional website and domain." },
];

export const PROCESS = [
  { num: "01", title: "Discover", desc: "First, I learn about your business, customers, goals, and what you want your website to accomplish." },
  { num: "02", title: "Design", desc: "I create the visual direction, layout, colors, typography, and overall experience." },
  { num: "03", title: "Build", desc: "I turn the design into a responsive, functional website." },
  { num: "04", title: "Refine", desc: "We review the website and make changes until everything feels right." },
  { num: "05", title: "Launch", desc: "Once everything is ready, the website goes live." },
];

export const WHY = [
  "Custom website designs",
  "Mobile-friendly layouts",
  "Modern visual design",
  "Clear communication",
  "Built around each business",
  "Affordable alternative to traditional agencies",
];

export const CARE = [
  "Good design",
  "Clear communication",
  "Attention to detail",
  "Making websites easy to use",
  "Helping small businesses look professional",
];

export const BRAND = "Naparstek Digital";
export const CONTACT_EMAIL = "a.naparstek@icloud.com";

// ─────────────────────────────────────────────────────────────
// TESTIMONIALS — real client quotes only.
// Replace the example entries below with genuine quotes from your
// clients (e.g. Alpaca Furniture, Stripes Lawn Care). To hide the
// whole section until you have real reviews, set this to: []
//   { quote: "...", name: "Client Name", role: "Business, City" }
// ─────────────────────────────────────────────────────────────
export const TESTIMONIALS = [
  {
    featured: true,
    quote:
      "Alec did a great job on our website. He was easy to work with, listened to what we wanted, and made the whole process really simple. We love how the website turned out and feel like it does a much better job showing off our work. We'd definitely recommend him if you're looking for someone to build or update your website.",
    name: "Sherry B.",
    role: "Alpaca Furniture Revitalization",
  },
  {
    quote:
      "Alec did a really good job with our website. He took the time to understand what we wanted and made the site look clean, professional, and easy to use. He was easy to communicate with and made changes when we asked. We're really happy with how it turned out and would definitely recommend him to other businesses.",
    name: "Stripes Lawn Care",
    role: "Olathe, Kansas",
  },
];
export const DISCIPLINES = ["Web Design", "SEO", "Branding", "Digital Solutions"];
export const BUDGETS = ["$500 – $1,000", "$1,000 – $2,500", "$2,500 – $5,000", "$5,000+", "Let's discuss"];
